import { Link } from '@utils/cook/types'
import { EntityType } from '@utils/entities'

export const ALLOWED_TYPES_OF_SPORT = ['soccer'] as const

export type AllowedTypeOfSport = (typeof ALLOWED_TYPES_OF_SPORT)[number]

export interface UseSportEntitySchedule {
  entityId: string
  typeOfSport: AllowedTypeOfSport
}

export interface SportEntityScheduleItem {
  isLive?: boolean
  matchId: string
  typeOfSport: AllowedTypeOfSport
  link?: Link
  startTime?: string
}

export type SportCompetitionScheduleRound = {
  id: string
  name: string
}

export type SportCompetitionScheduleApiProps = {
  typeOfSport: AllowedTypeOfSport
  entityType: Extract<EntityType, 'competition'>
  seasonId: string
}

export type SportCompetitionScheduleItem = SportEntityScheduleItem & {
  round: SportCompetitionScheduleRound
}

export interface SportCompetitionScheduleAPIResponse {
  rounds: SportCompetitionScheduleRound[]
  items: SportCompetitionScheduleItem[]
}

export type SportCompetitorScheduleApiProps = {
  typeOfSport: AllowedTypeOfSport
  entityType: Extract<EntityType, 'competitor'>
  competitorId: string
}

export type SportCompetitorScheduleItem = SportEntityScheduleItem

export type SportCompetitorScheduleAPIResponse = {
  items: SportCompetitorScheduleItem[]
}

export type SportCompetitionScheduleQueryResponse = {
  rounds: SportCompetitionScheduleRound[]
  items: Record<string, SportCompetitionScheduleItem[]>
}

export type SportEntityScheduleAPIProps = {
  typeOfSport: AllowedTypeOfSport
  entityType: Extract<EntityType, 'competition' | 'competitor'>
  seasonId?: string
  competitorId?: string
}
